var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _circle7, _circle8, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyFlossing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 145,
    viewBox: "0 0 244 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 113C68.9086 113 51 95.0914 51 73C51 50.9086 68.9086 33 91 33C113.091 33 131 50.9086 131 73C131 95.0914 113.091 113 91 113Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 145C83.6995 145 64 125.301 64 101C64 76.6995 83.6995 57 108 57C132.301 57 152 76.6995 152 101C152 125.301 132.301 145 108 145Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149 106C122.49 106 101 84.5097 101 58C101 31.4903 122.49 10 149 10C175.51 10 197 31.4903 197 58C197 84.5097 175.51 106 149 106Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146 138C119.49 138 98 116.51 98 90C98 63.4903 119.49 42 146 42C172.51 42 194 63.4903 194 90C194 116.51 172.51 138 146 138Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111 97C86.6995 97 67 77.3005 67 53C67 28.6995 86.6995 9 111 9C135.301 9 155 28.6995 155 53C155 77.3005 135.301 97 111 97Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 244 55)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 48 133)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 64)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 51 6)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 200 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 218 137)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.3584,
    y: 45.5195,
    width: 76,
    height: 76,
    rx: 5.28571,
    transform: "rotate(-5 83.3584 45.5195)",
    fill: "#2392F8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.526,
    cy: 80.0625,
    r: 28,
    transform: "rotate(-5 124.526 80.0625)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.526,
    cy: 80.0628,
    r: 12,
    transform: "rotate(-5 124.526 80.0628)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.873 27.489C105.825 26.9388 105.34 26.5318 104.79 26.58C104.24 26.6281 103.833 27.1131 103.881 27.6633L105.873 27.489ZM113.457 33.8523C109.605 34.1892 106.21 31.3403 105.873 27.489L103.881 27.6633C104.314 32.615 108.679 36.2779 113.631 35.8447L113.457 33.8523Z",
    fill: "#2392F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.373 30.9256L113.544 34.8477",
    stroke: "#2392F8",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.941 48.8573L123.082 52.082",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.941 48.8574L162.93 48.596C167.882 48.1627 171.545 43.7974 171.111 38.8458V38.8458C170.678 33.8942 166.313 30.2312 161.361 30.6644L158.373 30.9259",
    stroke: "#2392F8",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5L32 25.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215 24.5L233 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218 96.5L241 101.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 119L31 112.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyFlossing);
export default __webpack_public_path__ + "static/media/daily-flossing.1b7581412dd9885ddf965420a2f27aba.svg";
export { ForwardRef as ReactComponent };